<template>
    <div class="buble-holder-left">
        <v-checkbox :value="idmwhClave" v-model="checkmensaje" v-if="mclasificadoValue == 0"></v-checkbox>
        <div :id="idmwhClave" class="buble-container-left">
            <v-dialog v-model="imageModal" content-class="fullscreen-modal" dialog-class="dialog-style">
                <div class="image-container">
                    <div class="spinner-container" v-if="loadingModal">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                    </div>
                    <img id="imageFullScreen" v-if="!loadingModal" class="fullscreen-image"
                         :src="'data:image/png;base64,' + selectedImage" />
                </div>
            </v-dialog>

            <v-dialog v-model="vistoModal" content-class="VistoModal" persistent>
                <v-card>

                    <v-card-title style="display:block; text-align:center" class="justify-center primary">
                        <v-toolbar-title id="titulocard">Información Mensaje</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <div class="spinner-container text-center" v-if="loadingModal">
                        <v-progress-circular indeterminate color="green"></v-progress-circular>
                    </div>
                    <div v-if="!loadingModal">

                        <div class="text-center text-tittle">
                            <span class="text-subtitle"> Leido Por </span>
                            <i class="mdi mdi-check-all blue-icon"></i>
                        </div>
                        <div style="text-align: center;">


                            <div style="display: inline-block; text-align: left;">

                                <div class="borders" v-for="(item, index) in usuariosVisto" :key="index">

                                    <i class="mdi mdi-account-circle" style=" font-size: 1.5em;"></i>
                                    <span class="text-sup"> {{ item.uslogin }} - </span>
                                    <i class="mdi mdi-calendar-blank" style=" font-size: 1.5em;"></i>
                                    <span class="text-subtitle"> {{ item.bwhfhleido }} </span>



                                </div>



                            </div>



                        </div>

                    </div>


                    <div class="text-center btnCerrar">
                        <v-btn dark color="error" @click="vistoModal = false">
                            Cerrar
                        </v-btn>
                    </div>
                </v-card>



            </v-dialog>

            <v-dialog v-model="contactModal" content-class="VistoModal" persistent>
                <v-card style="min-height: 30vh;">
                    <v-card-title class="primary text-center">
                        <v-toolbar-title id="titulocard">Teléfonos</v-toolbar-title>
                    </v-card-title>

                    <v-card-text>
                        <v-list dense>
                            <template v-for="(contact, index) in phones">
                                <!-- Nombre del contacto -->
                                <v-list-item>
                                    <v-list-item-content>
                                        <span class="font-weight-bold">{{ contact.name }}</span>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider></v-divider>

                                <!-- Teléfonos del contacto -->
                                <template v-for="(phone, idx) in contact.phones">
                                    <v-list-item>
                                        <v-list-item-content class="text-center">
                                            <span>{{ phone.phone }} ({{ phone.type }})</span>
                                        </v-list-item-content>
                                    </v-list-item>
                                </template>

                                <v-divider></v-divider>
                            </template>
                        </v-list>
                    </v-card-text>


                    <v-card-actions class="justify-center">
                        <v-btn dark color="error" @click="contactModal = false">
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="emojieModal" content-class="EmojieModal" persistent>
                <v-card>
                    <v-card-title class="primary text-center">
                        <v-toolbar-title id="titulocard">Reaccionar a Mensaje</v-toolbar-title>
                    </v-card-title>

                    <v-card-text>
                        <div class="emoji-container">
                            <VEmojiPicker @select="selectEmoji" />
                        </div>
                    </v-card-text>


                    <v-card-actions class="justify-center">
                        <v-btn dark color="error" @click="emojieModal = false">
                            Cerrar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>



            <div v-if="MessageType == 'Image'">
                <div v-if="loadingImage == false">
                    <p class="text-right">

                        <v-menu offset-y>

                            <template v-slot:activator="{ on, attrs }">

                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon> mdi-dots-vertical </v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-btn style="width: 100%" color="primary"
                                           @click="DescargarMedia('Image')">Descargar</v-btn>
                                </v-list-item>
                                <v-list-item v-if="this.phoneNumber.Eliminado == '0' && this.mwhCopiedOnReport != 1">
                                    <v-btn style="width: 100%" color="primary" @click="DialogAdjuntar('Image')">
                                        Adjuntar al
                                        Reporte
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                    <v-icon class="btnInfo">mdi-information </v-icon>
                                </v-btn>
                            </template>
                            <span>Ver Información</span>
                        </v-tooltip>
                    </p>
                    <img id="ItemPreview" class="imagePreview" :src="'data:image/png;base64,' + FormattedMediaURL"
                         @click="openImageModal(FormattedMediaURL)" />
                    <p class="buble-text">{{ MessageText }}</p>
                </div>
                <div class="downloadbutton-container-empty" v-if="loadingImage == true">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
            </div>
            <div v-if="MessageType == 'Sticker'">
                <div v-if="loadingSticker == false">
                    <p class="text-right">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                    <v-icon class="btnInfo">mdi-information </v-icon>
                                </v-btn>
                            </template>
                            <span>Ver Información</span>
                        </v-tooltip>
                    </p>
                    <img v-if="MessageType == 'Sticker'"
                         id="ItemPreviewSticker"
                         class="stickerPreview"
                         :src="'data:image/webp;base64,' + FormattedMediaURL"
                         @click="openImageModal(FormattedMediaURL)" />
                </div>
                <div class="downloadbutton-container-empty" v-if="loadingSticker == true">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
            </div>
            <div v-if="MessageType == 'Video'">
                <div v-if="loadingVideo == false">
                    <p class="text-right">
                        <v-menu offset-y v-if="this.phoneNumber.Eliminado == '0' && this.mwhCopiedOnReport != 1">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon> mdi-dots-vertical </v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-btn style="width: 100%" color="primary" @click="DialogAdjuntar('Video')">
                                        Adjuntar al
                                        Reporte
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                    <v-icon class="btnInfo">mdi-information </v-icon>
                                </v-btn>
                            </template>
                            <span>Ver Información</span>
                        </v-tooltip>
                    </p>
                    <video v-if="AmazonBackupStatus != true" controls :name="MessageDate" type="video/mp4"
                           class="videoPreview" :src="'data:video/mp4;base64,' + FormattedMediaURL"></video>
                </div>
                <div :id="'video-' + idBubble"></div>
                <div class="downloadbutton-container-empty" v-if="loadingVideo == true">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
            </div>
            <div v-if="MessageType == 'Audio'">
                <div v-if="loadingAudio == false">
                    <p class="text-right">
                        <v-menu offset-y v-if="this.phoneNumber.Eliminado == '0' && this.mwhCopiedOnReport != 1">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon> mdi-dots-vertical </v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-btn style="width: 100%" color="primary" @click="DialogAdjuntar('Audio')">
                                        Adjuntar al
                                        Reporte
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                    <v-icon class="btnInfo">mdi-information </v-icon>
                                </v-btn>
                            </template>
                            <span>Ver Información</span>
                        </v-tooltip>
                    </p>
                    <audio controls :src="'data:audio/wav;base64,' + FormattedMediaURL"></audio>
                </div>
                <div class="downloadbutton-container-empty" v-if="loadingAudio == true">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
            </div>

            <div v-if="MessageType == 'Document'">
                <div style="height: 10px"></div>

                <div v-if="loadingDoc == false">
                    <p class="text-right">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <!--<v-btn color="primary" dark v-bind="attrs" v-on="on">
                            Dropdown
                        </v-btn>-->
                                <v-btn icon v-bind="attrs" v-on="on">
                                    <v-icon> mdi-dots-vertical </v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-item>
                                    <v-btn style="width: 100%" color="primary"
                                           @click="DescargarMedia('Document')">Descargar</v-btn>
                                </v-list-item>
                                <v-list-item v-if="this.phoneNumber.Eliminado == '0' && this.mwhCopiedOnReport != 1">
                                    <v-btn style="width: 100%" color="primary" @click="DialogAdjuntar('Document')">
                                        Adjuntar al
                                        Reporte
                                    </v-btn>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">

                                <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                    <v-icon class="btnInfo">mdi-information </v-icon>
                                </v-btn>
                            </template>
                            <span>Ver Información</span>
                        </v-tooltip>


                    </p>
                    <p class="buble-text-docs">{{ AttachFileName }}</p>
                </div>
                <div class="downloadbutton-container-empty" v-if="loadingDoc == true">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
            </div>
            <v-dialog transition="dialog-top-transition" content-class="dialog-reporte" v-model="modalAdj" persistent>
                <template>
                    <v-card style="height: 100%">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Adjuntar documento</v-toolbar-title>
                        </v-card-title>
                        <v-progress-linear color="green accent-4" indeterminate rounded height="6"
                                           v-if="cargarModal"></v-progress-linear>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <span style="
                            color: black;
                            text-align: center;
                            font-weight: bold;
                          ">Número de Reporte:</span>
                                    <multiselect v-model="ReportesDoc.Reporte"
                                                 deselect-label="No se puede remover el valor seleccionado"
                                                 selected-label="Seleccionado" select-label="Seleccione el reporte"
                                                 track-by="Reporte" label="Reporte" placeholder="Seleccione una opción"
                                                 :options="ReportesDoc.opcionesReportes" :allow-empty="false" :max-height="150">
                                    </multiselect>
                                    <span v-if="validareporte" class="spanError"
                                          style="color: red; font-size: 11px">Campo requerido</span>
                                    <div v-if="ReportesDoc.Reporte != null">
                                        <span style="font-weight:bold; color: black;">Asistencia: </span>
                                        <span>{{ this.ReportesDoc.Reporte.ainombre }}</span><br>
                                        <span style="font-weight:bold; color: black;">Estatus del reporte: </span>
                                        <span>{{ this.ReportesDoc.Reporte.Estatus }}</span><br>
                                        <span style="font-weight:bold; color: black;">Cliente: </span>
                                        <span>{{ this.ReportesDoc.Reporte.Cliente }}</span><br>
                                        <span style="font-weight:bold; color: black;">Abogado: </span>
                                        <span>{{ this.ReportesDoc.Reporte.Abogado }}</span><br>
                                        <span style="font-weight:bold; color: black;">Conductor: </span>
                                        <span>{{ this.ReportesDoc.Reporte.Conductor }}</span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" md="6" offset-md="3">
                                    <span style="
                            color: black;
                            text-align: center;
                            font-weight: bold;
                          ">
                                        Seleccione Documento:
                                    </span>
                                    <multiselect v-model="Documentos.Documento"
                                                 deselect-label="No se puede remover el valor seleccionado"
                                                 selected-label="Seleccionado" select-label="Seleccione un documento"
                                                 track-by="doclave" label="dodescrip" placeholder="Seleccione una opción"
                                                 :options="Documentos.opcionesDocumentos" :allow-empty="false" :max-height="150"
                                                 :disabled="showDocs">
                                    </multiselect>
                                    <span v-if="validadoc" class="spanError" style="color: red; font-size: 11px">
                                        Campo
                                        requerido
                                    </span>
                                </v-col>

                                <v-col cols="12" md="6" offset-md="3" style="justify-content: center; display: flex">
                                    <span style="
                            color: #1e88e5;
                            text-align: center;
                            font-size: x-large;
                          " class="mt-2">
                                        {{ this.AttachFileName }}
                                    </span>

                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions class="justify-center">
                            <v-btn variant="text" color="#536DFE" style="color: white" @click="AdjuntarDocumento()"
                                   :disabled="btnAdjDoc">Adjuntar</v-btn>
                            <v-btn variant="text" @click="CerrarModalAdjDoc()" color="default"
                                   :disabled="btnAdjDoc">Cerrar</v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-dialog>
            <div v-if="MessageType == 'Location'">
                <div style="height: 10px"></div>

                <div v-if="RenderMap == true">
                    <p class="text-right">
                        <!--<b-dropdown no-caret class="mx-1" variant="link" left>
                    <template slot="button-content">
                        <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click="SaveLocation()">Ubicacion Origen</b-dropdown-item>
                    <b-dropdown-item @click="SaveLocationDestino()">Ubicacion Destino</b-dropdown-item>
                </b-dropdown>-->
                    </p>
                    <GmapMap :center="{ lat: mapLat, lng: mapLong }" :zoom="14" map-type-id="terrain"
                             style="width: 500px; height: 300px">
                        <GmapMarker :position="{ lat: mapLat, lng: mapLong }" />
                    </GmapMap>
                </div>

                <p class="text-right">

                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                <v-icon class="btnInfo">mdi-information </v-icon>
                            </v-btn>
                        </template>
                        <span>Ver Información</span>
                    </v-tooltip>
                </p>
            </div>

            <div v-if="MessageType == 'Reply'">
                <div style="height: 10px"></div>
                <p class="text-right" style="margin-bottom: -0.5vh !important;">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                <v-icon class="btnInfo">mdi-information </v-icon>
                            </v-btn>
                        </template>
                        <span>Ver Información</span>
                    </v-tooltip>


                </p>
                <p class="buble-text" style="margin-bottom:8px">{{ MessageText }}</p>
                <div class="reply-container">
                    <p class="buble-text-reply">{{ ReplyText }}</p>
                </div>

            </div>


            <div v-if="MessageType == 'TextMessage'">
                <p class="text-right" style="margin-bottom: -0.5vh !important;">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                <v-icon class="btnInfo">mdi-information </v-icon>
                            </v-btn>
                        </template>
                        <span>Ver Información</span>
                    </v-tooltip>


                </p>
                <p class="buble-text">{{ MessageText }}</p>

            </div>
            <div v-if="MessageType == 'Contacts'">
                <p class="text-right" style="margin-bottom: -0.5vh !important;">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">

                            <v-btn v-bind="attrs" v-on="on" @click="VerVistos()" icon>
                                <v-icon class="btnInfo">mdi-information </v-icon>
                            </v-btn>
                        </template>
                        <span>Ver Información</span>
                    </v-tooltip>


                </p>
                <v-row align="center" style="margin-top: 1px; margin-right: 1px;">
                    <v-avatar color="grey darken-1" size="36" class="mr-2">
                        <v-icon color="white">mdi-account</v-icon>
                    </v-avatar>
                    <p class="buble-text">{{ formatearContact(MessageText) }}</p>
                </v-row>




                <!-- Botón que ocupa todo el ancho -->
                <v-btn block text color="primary" class="mt-2" @click="handleVerClick(MessageText)">
                    VER
                </v-btn>

            </div>
            <!-- Emoji en la esquina inferior derecha -->
            <span :class="{ 'emoji-bottom-right': mwhEmoji !== '' }">{{ mwhEmoji }}</span>
            <span @click="handleEmojiClick" :class="{ 'emoji-bottom-right1': mwhEmojiAusa !== '' }">{{ mwhEmojiAusa }}</span>
            <!--<p class="buble-text">{{ MessageText }}</p>-->
            <p class="text-left time-text">{{ MessageDate }}</p>

            <!-- Botón de Emoji alineado a la derecha -->
            <v-btn icon class="emoji-button" @click="toggleEmojiPanel()" >
                <v-icon class="mdi mdi-emoticon" style="font-size: 1.4em; color: gray;"></v-icon>
            </v-btn>


        </div>

    </div>
</template>
<!-- <script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyAlMQFjdtJRXoGZv0KUUDrg9cHwsCOh3NA" defer type="text/javascript"></script> -->

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
//import * as moment from "moment";
import WhatsappService from "@/services/Whatsapp/Whatsapp.service.js";
import Multiselect from "vue-multiselect";
import Vue from "vue";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import { VEmojiPicker } from "v-emoji-picker";
    import { parsePhoneNumber } from "awesome-phonenumber";
    export default {
        components: {
            VEmojiPicker
        },
    data() {
        return {
            formattedMediaURL: "",
            mapLat: "",
            mapLong: "",
            RenderMap: false,
            loadingDoc: false,
            loadingImage: false,
            loadingSticker: false,
            loadingVideo: false,
            loadingAudio: false,
            ReplyText: "",
            selectedImage: null,
            miniatureImage: true,
            urlMedia: "",
            loadingModal: false,
            reportSelectError: false,
            fileTypeError: false,
            saveReportButton: true,
            docsOnlyOneReport: true,
            uniqueReportText: "",
            selectedDocReport: null,
            docsReports: [],
            reporteModalLoading: false,
            reportSaveFileType: "",
            saveReportDialog: false,
            selectedFileType: null,
            reportFilesOptions: [],
            validdoctos: true,
            validplaca: false,
            buttondisabled: false,
            base64audio: "",
            visibleadjuntar: false,
            imageModal: false,
            checkmensaje: 0,
            modalAdj: false,
            ReportesDoc: {
                opcionesReportes: [],
                nrreporte: 0,
                svindice: 0,
                Reporte: null,
                aiclave: 0
            },
            Documentos: {
                opcionesDocumentos: [],
                doclave: 0,
                dodescripcion: 0,
                Documento: null,
            },
            showDocs: true,
            btnAdjDoc: false,
            validadoc: false,
            validareporte: false,
            cargarModal: false,
            typefile: null,
            mclasificadoValue: this.mclasificado,
            mwhCopiedOnReport: this.mwhFileCopiedOnReport,
            vistoModal: false,
            namePhone: '',
            phones: [],
            contactModal: false,
            usuariosVisto: [],
            emojieModal: false,
            
        };
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    props: [
        "MessageText",
        "MessageDate",
        "MessageAutor",
        "MessageType",
        "MediaURL",
        "AttachFileName",
        "AttachFileFormat",
        "Latitud",
        "Longitud",
        "AmazonBackupStatus",
        "ReplyId",
        "localIndex",
        "FormattedMediaURL",
        "idBubble",
        "phoneNumber",
        "idmwhClave",
        "mclasificado",
        "mwhFileCopiedOnReport",
        "mwhEmoji",
        "mwhEmojiAusa"
    ],

        async mounted() {
        var bubble = document.getElementById(this.idmwhClave);
        if (this.mclasificado == 1) {
            bubble.classList.add("buble-container-left");
        } else if (this.mclasificado == 0) {
            bubble.classList.add("buble-container-left-sinClasificar");
        }
        this.CheckMediaURL();
    },
    watch: {
        checkmensaje(val) {
            if (val != null) {
                this.$store.commit("seleccionarMensaje", val);
            } else {
                this.$store.commit("quitarMensaje", this.idmwhClave);
            }
        },
        mclasificadoValue(val) {
            var bubble = document.getElementById(this.idmwhClave);
            if (val == 1) {
                bubble.classList.remove("buble-container-left-sinClasificar");
                bubble.classList.add("buble-container-left");
            }
        },
        mclasificado(val) {
            this.mclasificadoValue = val;
        },
        async 'ReportesDoc.Reporte'(val) {
            if (val != null) {
                this.validareporte = false;
                await this.ObtenerCatalogo();
            }
        },
        async 'Documentos.Documento'(val) {
            if (val != null) {
                this.validadoc = false;
            }
        }
    },
        methods: {
            async handleEmojiClick() {                

                let number = this.phoneNumber.twhTelefono;
                number = number.replace("+", "");

                let formattedNumber = this.formatNumber(this.phoneNumber.twhTelefono);
                formattedNumber = formattedNumber.replace(/ /g, "");
                formattedNumber = formattedNumber.replace("+", "");

                let response = await WhatsappService.ReactToMessage(
                    this,
                    "",
                    number,
                    formattedNumber,
                    this.idBubble
                );

                this.$emit("updateEmojie", "", this.idmwhClave);


            },
            toggleEmojiPanel() {
                this.emojieModal = true;
            },
            async selectEmoji(emoji) {

                this.emojieModal = false;

                let auxText = emoji.data;
                let number = this.phoneNumber.twhTelefono;
                number = number.replace("+", "");

                let formattedNumber = this.formatNumber(this.phoneNumber.twhTelefono);
                formattedNumber = formattedNumber.replace(/ /g, "");
                formattedNumber = formattedNumber.replace("+", "");

                let response = await WhatsappService.ReactToMessage(
                    this,
                    auxText,
                    number,
                    formattedNumber,
                    this.idBubble
                );

                this.$emit("updateEmojie", auxText, this.idmwhClave);
            },
            formatNumber(number) {
                const pn = parsePhoneNumber(number);
                let formatted = pn.getNumber("international");
                return formatted;
            },
            handleVerClick(value) {

                try {
                    this.phones = JSON.parse(value); // Convierte la cadena JSON a un objeto
                    this.contactModal = true;
                } catch (e) {
                    console.error("Error al parsear el JSON:", e);
                }
                this.contactModal = true;



                //const parts = value.split("_");
                //const nameString = parts[0]; // Obtén la parte que contiene la lista de teléfonos

                //this.namePhone = nameString;
                //const phonesString = value.replace(nameString + '_', '');  //parts[1]; // Obtén la parte que contiene la lista de teléfonos
               
                //try {
                //    this.phones = JSON.parse(phonesString); // Convierte la cadena JSON a un objeto
                //    this.contactModal = true;
                //} catch (e) {
                //    console.error("Error al parsear el JSON:", e);
                //}
                //this.contactModal = true;

                ////const parts = value.split("_");
                ////this.phones = parts[1];
                ////this.contactModal = true;

            },
            formatearContact(value) {
                // Convertir el string a JSON
                let jsonValue = JSON.parse(value);
                if (jsonValue.length > 1) {
                    // Obtener el nombre del primer contacto
                    let firstName = jsonValue[0].name;
                    let total = jsonValue.length - 1;
                    return firstName + " y " + total.toString() + " más";
                }
                else {
                    let firstName = jsonValue[0].name;
                    return firstName;
                }

                

                //const parts = value.split("_");
                //return parts[0]; // Retorna el nombre antes del "_"
            },

        async SaveLocationDestino() {
            let resp = await WhatsappService.SaveLocationDestino(
                this.phoneNumber,
                this.mapLat,
                this.mapLong
            );
            if (resp.data == "0") {
                Vue.swal({
                    type: "error",
                    title: "Oops...",
                    text: "Ya se tiene un ubicación de destino registrada desde la página",
                    timer: 3000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            } else {
                Vue.swal({
                    type: "success",
                    title: "Correcto!",
                    text: "Se registró la ubicación de destino correctamente.",
                    timer: 4000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            }
        },
        async SaveLocation() {
            let resp = await WhatsappService.SaveLocation(
                this.phoneNumber,
                this.mapLat,
                this.mapLong
            );
            if (resp.data == "0") {
                Vue.swal({
                    type: "error",
                    title: "Oops...",
                    text: "Ya se tiene un ubicación de origen registrada desde la página",
                    timer: 3000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            } else {
                Vue.swal({
                    type: "success",
                    title: "Correcto!",
                    text: "Se registró la ubicación de origen correctamente.",
                    timer: 4000,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });

                let resp2 = await WhatsappService.NotificacionDestino(this.phoneNumber);

                if (resp2.data[0] == "1") {
                    let resp3 = await WhatsappService.EnviarNotificacionDestino(
                        this.phoneNumber,
                        resp2.data[1]
                    );
                }
            }
        },

        async openImageModal(imageData) {
            if (this.miniatureImage != true) {
                this.selectedImage = imageData;
                this.loadingModal = false;
                this.imageModal = true;
            } else {
                this.loadingModal = true;
                this.imageModal = true;
                let response = await WhatsappService.ObtenerMultimediaAmazon(
                    this,
                    this.MediaURL,
                    this.AttachFileName
                );
                this.selectedImage = response.data;
                this.loadingModal = false;
            }
        },
        closeImageModal() {
            this.imageModal = false;
        },
        async CheckMediaURL() {
            if (this.MediaURL != "") {
                await this.ObtenerMediaURL(this.MediaURL, this.MessageType);
            }
            if (this.MessageType == "Location") {
                this.RenderizaMapa();
            }
            if (this.MessageType == "Reply") {
                this.BuscaTextoRespuesta();
            }
        },

        EmitMediaDataToMessages(index, data) {
            this.$emit("mediaURLEmitWatcher", index, data);
        },
        cancel() {
            this.buttondisabled = true;
        },
        async ObtenerMediaURL(mediaURL, contentType) {
            this.urlMedia = mediaURL;
            if (this.FormattedMediaURL == "" || this.FormattedMediaURL == undefined) {
                switch (contentType) {
                    case "Image":
                        this.loadingImage = true;

                        let imageMini = this.AttachFileName;

                        if (this.AmazonBackupStatus == true) {
                            let responseS3 = await WhatsappService.ObtenerMultimediaAmazon(
                                this,
                                mediaURL,
                                imageMini.replace(".", "-TB.")
                            );

                            if (responseS3.status != 204) {
                                this.miniatureImage = true;
                                await this.EmitMediaDataToMessages(
                                    this.localIndex,
                                    responseS3.data
                                );
                            } else {
                                //let responseS3 = await WhatsappService.ObtenerMultimediaAmazon(
                                //    mediaURL,
                                //    this.AttachFileName,
                                //    //this.AttachFileName,
                                //    this.$store.state.urlBucketAmazon
                                //);
                                //this.miniatureImage = false;
                                //await this.EmitMediaDataToMessages(
                                //    this.localIndex,
                                //    responseS3.data
                                //);
                            }
                            this.loadingImage = false;
                        } else {
                            let response = await WhatsappService.ObtenerContenidoMultimedia(
                                this,
                                mediaURL
                            );

                            if (response[0].value.error == true) {
                                return "";
                            } else {
                                await this.EmitMediaDataToMessages(
                                    this.localIndex,
                                    response[0].value.msg
                                );
                                this.formattedMediaURL = response[0].value.msg;
                                this.miniatureImage = false;
                                this.loadingImage = false;
                            }
                            /*}*/
                        }

                        break;
                    case "Sticker":
                        this.loadingSticker = true;

                        let stickerMini = this.AttachFileName;

                        if (this.AmazonBackupStatus == true) {
                            let responseS3 = await WhatsappService.ObtenerMultimediaAmazon(
                                this,
                                mediaURL,
                                stickerMini.replace(".", "-TB.")
                            );
                            if (responseS3.status != 204) {
                                this.miniatureImage = true;
                                await this.EmitMediaDataToMessages(
                                    this.localIndex,
                                    responseS3.data
                                );
                            } else {
                                //let responseS3 = await WhatsappService.ObtenerMultimediaAmazon(
                                //    mediaURL,
                                //    this.AttachFileName,
                                //    //this.AttachFileName,
                                //    this.$store.state.urlBucketAmazon
                                //);
                                //this.miniatureImage = false;
                                //await this.EmitMediaDataToMessages(
                                //    this.localIndex,
                                //    responseS3.data
                                //);
                            }
                            this.loadingSticker = false;
                        } else {
                            let response = await WhatsappService.ObtenerContenidoMultimedia(
                                this,
                                mediaURL
                            );
                            if (response[0].value.error == true) {
                                return "";
                            } else {
                                await this.EmitMediaDataToMessages(
                                    this.localIndex,
                                    response[0].value.msg
                                );
                                this.formattedMediaURL = response[0].value.msg;
                                this.miniatureImage = false;
                                this.loadingSticker = false;
                            }
                            /*}*/
                        }

                        break;

                    case "Video":
                        this.loadingVideo = true;
                        if (this.AmazonBackupStatus == true) {
                            this.formattedMediaURL =
                                "https://player.vimeo.com/video/" + mediaURL.toString();
                            var blobMe = URL["createObjectURL"](
                                new Blob([""], { type: "text/html" })
                            );
                            var videoId = "video-" + this.idBubble.toString();
                            var elIframe = document["createElement"]("iframe");
                            elIframe["setAttribute"]("frameborder", "0");
                            elIframe["setAttribute"]("width", "100%");
                            elIframe["setAttribute"]("height", "500px");
                            elIframe["setAttribute"]("min-width", "380px");
                            elIframe["setAttribute"]("min-height", "500px");
                            elIframe["setAttribute"]("allowfullscreen", "true");
                            elIframe["setAttribute"]("webkitallowfullscreen", "true");
                            elIframe["setAttribute"]("mozallowfullscreen", "true");
                            elIframe["setAttribute"]("src", blobMe);
                            var idOne = "gepa_" + Date.now();
                            elIframe["setAttribute"]("id", idOne);
                            document.getElementById(videoId).appendChild(elIframe);
                            const iframeHere =
                                "https://player.vimeo.com/video/" + mediaURL.toString();
                            document["getElementById"](idOne)["contentWindow"][
                                "document"
                            ].write(
                                '<script type="text/javascript">location.href = "' +
                                iframeHere +
                                '";\x3c/script>'
                            );

                            this.loadingVideo = false;
                        } else {
                            let responseVideo =
                                await WhatsappService.ObtenerContenidoMultimedia(
                                    this,
                                    mediaURL
                                );

                            if (responseVideo[0].value.error == true) {
                                return "";
                            } else {
                                await this.EmitMediaDataToMessages(
                                    this.localIndex,
                                    responseVideo[0].value.msg
                                );
                                this.formattedMediaURL = responseVideo[0].value.msg;
                                this.loadingVideo = false;
                            }

                            //let response = await WhatsappService.ObtenerContenidoMultimedia(this,
                            //    mediaURL
                            //);

                            //if (response[0].value.error == true) {
                            //    return "";
                            //}
                            //else {
                            //    await this.EmitMediaDataToMessages(
                            //        this.localIndex,
                            //        response[0].value.msg
                            //    );
                            //    this.formattedMediaURL = response[0].value.msg;
                            //    this.miniatureImage = false;
                            //    this.loadingImage = false;

                            //}
                        }
                        break;

                    case "Audio":
                        this.loadingAudio = true;
                        if (this.AmazonBackupStatus == true) {
                            //del bucket
                            let responseS3Audio =
                                await WhatsappService.ObtenerMultimediaAmazon(
                                    this,
                                    mediaURL,
                                    this.AttachFileName
                                );

                            this.base64audio = responseS3Audio.data;
                            await this.EmitMediaDataToMessages(
                                this.localIndex,
                                responseS3Audio.data
                            );

                            this.loadingAudio = false;
                        } else {
                            // de facebook

                            let response = await WhatsappService.ObtenerContenidoMultimedia(
                                this,
                                mediaURL
                            );

                            if (response[0].value.error == true) {
                                return "";
                            } else {
                                await this.EmitMediaDataToMessages(
                                    this.localIndex,
                                    response[0].value.msg
                                );
                                this.formattedMediaURL = response[0].value.msg;
                                this.loadingAudio = false;
                            }
                        }
                        break;

                    case "Document":
                        this.loadingDoc = true;
                        if (this.AmazonBackupStatus == true) {
                            let responseS3Doc = await WhatsappService.ObtenerMultimediaAmazon(
                                this,
                                mediaURL,
                                this.AttachFileName
                            );
                            await this.EmitMediaDataToMessages(
                                this.localIndex,
                                responseS3Doc.data
                            );

                            this.loadingDoc = false;
                        } else {
                            let response = await WhatsappService.ObtenerContenidoMultimedia(
                                this,
                                mediaURL
                            );

                            if (response[0].value.error == true) {
                                return "";
                            } else {
                                await this.EmitMediaDataToMessages(
                                    this.localIndex,
                                    response[0].value.msg
                                );
                                this.formattedMediaURL = response[0].value.msg;
                                this.loadingDoc = false;
                            }
                        }
                        break;

                    default:
                        break;
                }
            }
            //this.loadingVideo = false;
        },

        RenderizaMapa() {
            this.mapLat = this.Latitud;
            this.mapLong = this.Longitud;

            setTimeout(() => {
                this.RenderMap = true;
            }, 1000);
        },

        async BuscaTextoRespuesta() {
            let responsebody = await WhatsappService.ObtenerTextoRespuesta(
                this,
                this.ReplyId
            );

            this.ReplyText = responsebody[0].mwhBody;
        },

        DescargarMedia(type) {
            switch (type) {
                case "Image":
                    this.DescargarImagen(this.MessageDate);
                    break;
                case "Video":
                    this.DescargarVideo(this.MessageDate);
                    break;
                case "Document":
                    this.DescargarDocumento(this.MessageDate);
                    break;
            }
        },

        DescargarDocumento(filename) {
            const linkSource = `data:application/pdf;base64,${this.FormattedMediaURL}`;
            const downloadLink = document.createElement("a");
            const file = "WhatsappDocument" + filename;
            downloadLink.href = linkSource;
            downloadLink.download = file;
            downloadLink.click();
        },

        DescargarVideo(filename) {
            const linkSource = `data:video/mp4;base64,${this.FormattedMediaURL}`;
            const downloadLink = document.createElement("a");
            const file = "WhatsappVideo" + filename;
            downloadLink.href = linkSource;
            downloadLink.download = file;
            downloadLink.click();
        },

        async DescargarImagen(filename) {

            let linkSource = "";
            if (this.miniatureImage == false) {
                linkSource = `data:image/png;base64,${this.FormattedMediaURL}`;
            } else {
                let responseS3 = await WhatsappService.ObtenerMultimediaAmazon(
                    this,
                    this.MediaURL,
                    this.AttachFileName
                );

                linkSource = `data:image/png;base64,${responseS3.data}`;
            }

            const downloadLink = document.createElement("a");
            const file = "WhatsappImage" + filename;
            downloadLink.href = linkSource;
            downloadLink.download = file;
            downloadLink.click();
        },
        async DialogAdjuntar(type) {
            this.typefile = type;
            this.modalAdj = true;
            if (this.phoneNumber.stadescripcion == 'Abogado' || this.phoneNumber.stadescripcion == 'Supervisor') {
                let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
                await WhatsappService.ObtenerReportesAsociados(this, null, datos.nrreporte, datos.svindice);
            } else {
                await WhatsappService.ObtenerReportesAsociados(this, this.phoneNumber.twhTelefono, null, null);
            }
        },
        async ObtenerCatalogo() {
            await WhatsappService.ObtenerCatalogo(this, this.ReportesDoc.Reporte.nrreporte, this.ReportesDoc.Reporte.svindice, this.ReportesDoc.Reporte.aiclave, this.typefile);
            this.showDocs = false;
        },

        async VerVistos() {

            this.vistoModal = true;
            this.loadingModal = true;
            let datos = await WhatsappService.ObtenerVistos(this, this.idmwhClave);
            this.loadingModal = false;

            this.usuariosVisto = datos;

        },

        CerrarModalAdjDoc() {
            this.modalAdj = false;
            this.ReportesDoc.Reporte = null;
            this.Documentos.Documento = null;
            this.showDocs = true;
            this.validadoc = false;
            this.validareporte = false;
            this.btnAdjDoc = false;
        },
        updateMclasificado(newValue) {
            this.mclasificadoValue = newValue;
            this.mwhCopiedOnReport = newValue;
        },
        async AdjuntarDocumento() {
            if (this.ReportesDoc.Reporte != null) {
                if (this.Documentos.Documento != null) {
                    this.btnAdjDoc = true;
                    this.cargarModal = true;
                    if (this.AmazonBackupStatus != true) {
                        let ruta = await WhatsappService.ValidarRuta(this, this.idBubble);
                        if (ruta.length == 0) {
                            this.modalAdj = false;
                            this.cargarModal = false;
                            this.$swal({
                                type: "error",
                                title: "Ocurrio un error",
                                text: "Por favor, inténtelo de nuevo",
                                position: "center",
                                icon: "error",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    this.CerrarModalAdjDoc();
                                }
                            });
                        } else {
                            if (this.MessageType == 'Audio' && this.base64audio == "") {
                                let responseS3Audio =
                                    await WhatsappService.ObtenerMultimediaAmazon(this, ruta[0].mwhMediaUrl, this.AttachFileName);
                                this.base64audio = responseS3Audio.data;
                            }
                            let response = await WhatsappService.AdjuntarArchivoAlReporte(this, this.idBubble, this.ReportesDoc.Reporte.nrreporte, this.ReportesDoc.Reporte.svindice,
                                this.Documentos.Documento.doclave, this.MessageType, this.AttachFileName, ruta[0].mwhMediaUrl, this.base64audio);
                            if (response.data.error == false) {
                                this.modalAdj = false;
                                this.cargarModal = false;
                                this.$swal({
                                    type: "success",
                                    title: "Éxito",
                                    text: response.data.msg,
                                    position: "center",
                                    icon: "success",
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        this.updateMclasificado(1)
                                        this.CerrarModalAdjDoc();
                                    }
                                });
                            } else {
                                this.modalAdj = false;
                                this.cargarModal = false;
                                this.$swal({
                                    type: "error",
                                    title: "Ocurrio un error",
                                    text: response.data.msg,
                                    position: "center",
                                    icon: "error",
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                }).then(async (result) => {
                                    if (result.isConfirmed) {
                                        this.CerrarModalAdjDoc();
                                    }
                                });
                            }
                        }
                    } else {
                        let response = await WhatsappService.AdjuntarArchivoAlReporte(this, this.idBubble, this.ReportesDoc.Reporte.nrreporte, this.ReportesDoc.Reporte.svindice,
                            this.Documentos.Documento.doclave, this.MessageType, this.AttachFileName, this.MediaURL, this.base64audio);
                        if (response.data.error == false) {
                            this.modalAdj = false;
                            this.cargarModal = false;
                            this.$swal({
                                type: "success",
                                title: "Éxito",
                                text: response.data.msg,
                                position: "center",
                                icon: "success",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    this.updateMclasificado(1)
                                    this.CerrarModalAdjDoc();
                                }
                            });
                        } else {
                            this.modalAdj = false;
                            this.cargarModal = false;
                            this.$swal({
                                type: "error",
                                title: "Ocurrio un error",
                                text: response.data.msg,
                                position: "center",
                                icon: "error",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then(async (result) => {
                                if (result.isConfirmed) {
                                    this.CerrarModalAdjDoc();
                                }
                            });
                        }
                    }



                } else {
                    this.validadoc = true;
                }
            } else {
                this.validareporte = true;
            }
        }

    },
    beforeUnmount() {
        this.MessageText = null;
        this.MessageDate = null;
        this.MessageAutor = null;
        this.MediaURL = null;
        this.AttachFileName = null;
        this.AttachFileFormat = null;
        this.Latitud = null;
        this.Longitud = null;
        this.AmazonBackupStatus = null;
        this.ReplyId = null;
        this.localIndex = null;
    },
};
</script>

<style>
.btnInfo {
    color: gray !important;
}

.image-1 {
    filter: invert(100%);
    -webkit-filter: invert(100%);
}

.btnCerrar {
    margin-top: 8vh !important;
    margin-bottom: 1vh !important;
}

.blue-icon {
    color: #007cc9;
}

.buble-text {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    font-size: 16px;
    color: #111b21;
}

.VistoModal {
    width: 25vw !important;
    height: auto;
    min-height: 30vh;
    max-height: 80vh !important;
    scrollbar-width: thin;
}



    .EmojieModal {
        width: 29vw !important;
        height: auto;
        min-height: 30vh;
        max-height: 80vh !important;
        scrollbar-width: thin;
    }

    .emoji-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
    }

        .emoji-container .v-emoji-picker {
            width: 100% !important;
            max-width: none !important;
        }



::-webkit-scrollbar {
    width: 9px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: rgba(155, 155, 155, 0.5);
    border-radius: 20px;
    border: transparent;
}

* {
    scrollbar-width: thin;
}

@media screen and (max-width: 1200px) {


    .VistoModal {
        width: 50% !important;
    }



    .EmojieModal {
        width: 50% !important;
    }


}

@media screen and (max-width: 767px) {


    .VistoModal {
        width: 80% !important;
    }



    .EmojieModal {
        width: 80% !important;
    }


}


@media screen and (max-width: 500px) {


    .VistoModal {
        width: 100% !important;
    }



    .EmojieModal {
        width: 100% !important;
    }
}

.text-sup {
    font-family: Poppins, sans-serif;
    font-size: 1.1em;
}

.text-tittle {
    margin-top: 2vh !important;
    margin-bottom: 2vh !important;
}

.borders {
    margin-top: 1vh !important;
    margin-bottom: 1vh !important;

}

.text-subtitle {
    font-family: Poppins, sans-serif;
    font-size: 1em;
    color: #7e7e7e;
}

.error-span {
    font-weight: 410;
    font-size: 13px;
    color: red;
}

.report-select {
    width: auto;
    min-width: 250px;
}

.dialog-style {
    margin-left: 2.4vw !important;
    margin-right: 2.4vw !important;
    margin-top: 2.4vh !important;
    margin-bottom: 2.4vh !important;
}

.report-dialog-style {
    margin-left: 3.5vw !important;
    margin-right: 3.5vw !important;
    margin-top: 10vh !important;
    margin-bottom: 10vh !important;
}

@media screen and (min-width: 700px) {
    .report-dialog-style {
        margin-left: 19vw !important;
        margin-right: 19vw !important;
        margin-top: 10vh !important;
        margin-bottom: 10vh !important;
    }
}

.report-modal {
    width: 60vw !important;
    height: auto !important;

    min-width: 360px;
    min-height: 400px;
}

.report-container {
    display: flex !important;
    margin-left: auto !important;
    margin-right: auto !important;
    padding: 10px;
}

.files-report-label-style {
    font-family: "Work Sans", sans-serif;
    font-weight: 800;
    font-size: 14px;
    color: #1e1e1f;
}

.files-label-style {
    font-family: "Work Sans", sans-serif;
    font-weight: 800;
    font-size: 14px;
    color: #1e1e1f;
}

.file-to-add-style {
    font-family: "Work Sans", sans-serif;
    font-weight: 500;
    font-size: 12px;
    color: #6c757d;
}

.fullscreen-modal {
    width: 90vw !important;
    height: 85vh !important;
    background: white;
}

.fullscreen-image {
    /*max-width: 80vw !important;
    max-height: 85vh !important;*/
    /*margin-left: auto !important;
    margin-right: auto !important;*/

    max-width: 70vw !important;
    max-height: 80vh !important;
    position: relative;
    margin: auto;
    top: 2vh;
    left: 0;
    right: 0;
    bottom: 0;
}

.image-container {
    display: flex !important;
    margin-left: auto !important;
    margin-right: auto !important;
}

.spinner-container {
    /*display: flex !important;
    margin-left: auto !important;
    margin-right: auto !important;
    width: 50px;*/
    max-width: 70vw !important;
    max-height: 80vh !important;
    position: relative;
    margin: auto;
    top: 2vh;
    left: 0;
    right: 0;
    bottom: 0;
}

.imagePreview {
    width: 160px;
    height: auto !important;
    object-fit: fill !important;
}

@media screen and (min-width: 700px) {
    .imagePreview {
        width: 180px;
        height: auto !important;
        object-fit: fill !important;
    }
}

    .stickerPreview {
        width: 85px;
        height: auto !important;
        object-fit: contain !important;
    }

    @media screen and (min-width: 700px) {
        .stickerPreview {
            width: 95px;
            height: auto !important;
            object-fit: contain !important;
        }
    }




</style>

<style lang="scss" scoped>
    .buble-container-left:hover .emoji-button {
        opacity: 1; /* El botón se vuelve visible al pasar el mouse */
        pointer-events: auto;  /*Habilitar interacción con el botón */
    }

    .emoji-button {
        position: absolute;
        top: 50%;
        right: -33px;
        transform: translateY(-50%);
        font-size: 1.4em;
        color: gray;
        opacity: 0; /* El botón comienza invisible */
        pointer-events: none;  /*El botón no interactúa cuando está invisible */
        transition: opacity 0.3s ease;  /*Transición suave */
    }
    .emoji-bottom-right {
        position: absolute;
        bottom: -25px; /* Mueve más abajo el círculo */
        left: 10px; /* Puedes ajustar esto para moverlo más a la derecha */
        width: 35px; /* Ancho del círculo */
        height: 35px; /* Altura del círculo */
        background: #ffffff; /* Fondo blanco */
        border-radius: 50%; /* Hace el contenedor circular */
        border: 2px solid #ddd; /* Borde alrededor del círculo */
        display: flex; /* Centra el emoji */
        align-items: center; /* Centra verticalmente el emoji */
        justify-content: center; /* Centra horizontalmente el emoji */
        font-size: 1.2em; /* Tamaño del emoji */
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Sombra para un efecto más suave */
        pointer-events: none; /* Hace que no sea interactivo */
    }



    .emoji-bottom-right1 {
        position: absolute;
        bottom: -25px;
        left: 46px;
        width: 35px;
        height: 35px;
        background: #bdccf7;
        border-radius: 50%;
        border: 2px solid #bdccf7;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.2em;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        pointer-events: auto; /* Permitir interacción */
        cursor: pointer; /* Indicar que se puede hacer clic */
    }
.downloadbutton-container {
    width: 35px;
    height: 35px;
    background-color: #4d4d4d;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    border-radius: 50%;
    margin-top: 10px;
}

.downloadbutton-container-empty {
    width: 35px;
    height: 35px;
    text-align: center;
    vertical-align: middle;
    line-height: 35px;
    border-radius: 50%;
    margin-top: 10px;
}

.buble-text {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    font-size: 16px;
    color: #111b21;
}

.buble-text-docs {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    font-size: 14px;
    color: #5f5f5f;
}

.buble-text-reply {
    margin: 0;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    word-spacing: 3px;
    font-size: 14px;
    color: #313131;
}

.buble-holder-left {
    display: flex;
    justify-content: start;
    margin-bottom: 20px;
}

.buble-container-left {
    position: relative;
    background: #ffffff;
    border-radius: 0.4em;
    padding: 10px 20px 10px 30px;
    width: auto;
    min-width: auto;
    max-width: 85% !important;
    margin-bottom: 10px;
    height: auto;




}

.buble-container-left-sinClasificar {
    position: relative;
    background: #dbebff;
    border-radius: 0.4em;
    padding: 10px 20px 10px 30px;
    width: auto;
    min-width: auto;
    max-width: 85% !important;
    margin-bottom: 10px;
    height: auto;
}

@media only screen and (max-width: 507px) {
    .buble-container-left {
        position: relative;
        background: #ffffff;
        border-radius: 0.4em;
        padding: 10px 20px 10px 30px;
        width: auto;
        min-width: 220px;
        max-width: 85% !important;
        margin-bottom: 10px;
        height: auto;




    }

    .buble-container-left-sinClasificar {
        position: relative;
        background: #dbebff;
        border-radius: 0.4em;
        padding: 10px 20px 10px 30px;
        width: auto;
        min-width: 220px;
        max-width: 85% !important;
        margin-bottom: 10px;
        height: auto;




    }
}

.buble-container-left:after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 0.625em solid transparent;
    border-right-color: #ffffff;
    border-left: 0;
    margin-top: -0.625em;
    margin-left: -0.625em;
}

.buble-container-left-sinClasificar:after {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    width: 0;
    height: 0;
    border: 0.625em solid transparent;
    border-right-color: #dbebff;
    border-left: 0;
    margin-top: -0.625em;
    margin-left: -0.625em;
}

.time-text {
    margin: 0;
    margin-top: 10px;
    font-family: "Work Sans", sans-serif;
    font-weight: 400;
    font-size: 12px;
    color: #111b21;
}

.videoPreview {
    width: auto;
    //max-width: 320px !important;
    height: 320px !important;
}

.download-icon {
    font-size: 16px;
    color: rgb(26, 26, 26);
}

.download-icon:hover {
    font-size: 16px;
    color: #25d366;
}

.download-docsIcon {
    font-size: 16px;
    color: white;
}

.download-docsIcon:hover {
    font-size: 16px;
    color: #25d366;
}

.reply-container {
    background-color: #dddddd;
    padding: 10px 10px 10px 10px;
    margin-bottom: 5px;
    border-radius: 10px;
}
</style>
